import { IGroupData } from "../models/Group";

export const listGroupsAdapter = (courses: IGroupData[]) => {
    return {
        data: courses.map(course => {
            return {
                id: course.id,
                name: course.name,
                description: course.description
            }
        })
    }
}